import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {MX_STANDARD_ANIMATION_TIMINGS} from '@aviary/store/common/common.types';
import {MatIcon} from '@angular/material/icon';
import {IconButtonComponent} from '@aviary/buttons/icon-button/icon-button.component';

export type ChevronOrientation = 'right' | 'down';

@Component({
  selector: 'mx-rotating-chevron',
  template: `
    <mx-icon-button [tooltip]="orientation === 'right' ? 'See more' : 'See less'" [customContentTemplate]="chevronIcon"/>

    <ng-template #chevronIcon>
      <mat-icon [@rotateChevron]="orientation">chevron_right</mat-icon>
    </ng-template>
  `,
  animations: [
    trigger('rotateChevron', [
      state('right', style({transform: 'rotate(0deg)'})),
      state('down', style({transform: 'rotate(90deg)'})),
      transition('right <=> down', animate(MX_STANDARD_ANIMATION_TIMINGS)),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, IconButtonComponent]
})
export class RotatingChevronComponent {

  @Input() public orientation: ChevronOrientation = 'right';
}
